export default "__VITE_ASSET__3755ee47__"